export default {
  meta: {
    title: '拓店计划',
    url: '/locxx/storeexpansiontasks',
    parentPath: ['/locxx'],
    breadcrumbs: {
      path: ['/locxx/storeexpansiontasks'],
      name: ['拓店计划'],
    },
  },
};
